// extracted by mini-css-extract-plugin
module.exports = {"fileDialogInput":"picture_fileDialogInput_2ZaPe","disabled":"picture_disabled_31ZaH"};